import PropTypes from "prop-types"
import { noop } from "lodash"
import { Table } from "@mui/material"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData } from "helpers/contributorsSort"
import { VIEW_TYPES } from "helpers/base"
import ContributorsTableGroupHead from "components/contributors-table-group-head"

function ContributorsTotal({ disabled, data, viewType, show, drift, displayTypeName, factorTable, groupSort, groupOrder }) {
  return <Table className="beta-contributors">
    <ContributorsTableGroupHead {...{
      tooltipText: "Beta",
      displayTypeName,
      groupOrder,
      groupSort,
      label: `Beta (${viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"})`,
    }}
    />
    <ContributorsTableContent
      driftType="Beta"
      factors
      noPercent
      allFactors
      drift={drift}
      openFactorProfile={noop}
      data={sortData(data, groupOrder)}
      show={show}
      factorTable={factorTable}
      disabled={disabled}
    />
  </Table>
}

ContributorsTotal.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  displayTypeName: PropTypes.string.isRequired,
  show: PropTypes.func.isRequired,
  factorTable: PropTypes.bool.isRequired,
  drift: PropTypes.object.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
}

export default ContributorsTotal
